<template>
  <div class="pagination-group">
    <div class="pagination-btn-prev" @click="startPage">
      <i class="material-icons unselect" style="margin-top:5px;margin-right:-18px">keyboard_arrow_left</i>
      <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
    </div>
    <div class="pagination-btn-prev" @click="prevPage">
      <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
    </div>
    <div class="pagination-num" v-for="(n,idx) in calcPageList" :key="'page-'+idx">
        <span
          class="unselect"
          :class="{
            'pagination-num-selected': n === page_num,
            'pagination-num-not-selected': n !== page_num,
          }"
          @click="changePage(n)"
          style="font-size:1.2rem">{{ n }}</span>
    </div>
    <div class="pagination-btn-next" @click="nextPage">
      <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
    </div>
    <div class="pagination-btn-next" @click="endPage">
      <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
      <i class="material-icons unselect" style="margin-top:5px;margin-left:-18px">keyboard_arrow_right</i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Pagination",
    created() {

    },
    props: {
      total_page: {
        type: Number
      }
    },
    data() {
      return {
        page_num: 1
      }
    },
    methods: {
      startPage() {
        this.page_num = 1;
      },
      prevPage() {
        if(this.page_num>1) {
          this.page_num--;
        }
      },
      changePage(n) {
        this.page_num = n;
      },
      nextPage() {
        if(this.page_num < this.total_page) {
          this.page_num++;
        }
      },
      endPage() {
        this.page_num = this.total_page;
      }
    },
    watch: {
      page_num(n) {
        this.$emit('change',n);
      }
    },
    computed: {
      calcPageList() {
        let list = [];
        for(let i=1; i<=this.total_page;i++) {
          list.push(i);
        }
        return list;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .pagination-group
    display: flex
    flex-wrap: wrap
    justify-content: center
    align-items: center
    margin-top: 20px


  .pagination-btn-prev
  .pagination-btn-next
  .pagination-num
    display: inline-block

  .pagination-btn-prev i
  .pagination-btn-next i
    color: #18a4ed
    margin: 4px
    cursor: pointer


  .pagination-num
    padding: 5px 8px
    cursor: pointer
    font-size: .9rem


  .pagination-num-selected
    color: #18a4ed


  .pagination-num-not-selected
    color: #666

</style>
